import { SDK } from '../index';
import {
    PredefinedMessageInput,
    PredefinedMessage,
    PredefinedMessagesQueryVariables,
    SendMessageResult,
    SendPredefinedMessageMutationVariables,
    ResultSuccess,
} from '../generated/graphql';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';

export const findManyPredefinedMessage = async (
    sdk: SDK,
    fetchPolicy: FetchPolicy = 'cache-first',
): Promise<Array<PredefinedMessage> | ResultSuccess> => {
    const query = require('../graphql/queries/predefinedMessages.query.gql');
    return sdk.query<
        {
            findManyPredefinedMessage: Array<PredefinedMessage>;
        },
        PredefinedMessagesQueryVariables
    >(
        {
            query: query,
            fetchPolicy,
        },
        'findManyPredefinedMessage',
    );
};

export const sendPredefinedMessage = async (
    data: PredefinedMessageInput,
    sdk: SDK,
): Promise<SendMessageResult | ResultSuccess> => {
    const mutation = require('../graphql/mutations/sendPredefinedMessage.mutation.gql');
    return sdk.mutate<
        {
            sendPredefinedMessage: SendMessageResult;
        },
        SendPredefinedMessageMutationVariables
    >(
        {
            mutation: mutation,
            variables: { s_Data: data },
        },
        'sendPredefinedMessage',
    );
};
